import { render } from "./Reminder.vue?vue&type=template&id=036b5b40&scoped=true&ts=true"
import script from "./Reminder.vue?vue&type=script&lang=ts"
export * from "./Reminder.vue?vue&type=script&lang=ts"

import "./Reminder.vue?vue&type=style&index=0&id=036b5b40&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036b5b40"]])

export default __exports__